import styled from "styled-components";

export const TextContainer = styled.div`
    width: 100%;
    height: 76px;
    display: flex;
    justify-content: center;
`;

export const TextMessage = styled.p`
    width: 250px;
    text-align: center;
    color: #F58B1E;
    font: normal normal normal 32px/44px Circular Std Book;
`

export const ImageContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 70px;
`

export const ModalFooter = styled.div`
    height: 140px;
    align-items: flex-start;
    padding: 0;
`
